module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: _vm.component_class
  }, [_c('i', {
    staticClass: "radio-icon"
  }, [_c('transition', {
    attrs: {
      "name": "bounce"
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_active),
      expression: "is_active"
    }],
    staticClass: "active-sign",
    style: (_vm.active_style)
  })])], 1), _vm._v(" "), _c('input', {
    staticClass: "hidden-input",
    attrs: {
      "id": _vm._uid,
      "type": "radio"
    },
    domProps: {
      "value": _vm.cur_value
    },
    on: {
      "click": function($event) {
        !_vm.disabled && _vm.triggerHandler(_vm.cur_value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label",
    attrs: {
      "for": _vm._uid
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-669c7c6b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Radio/Radio.vue
// module id = 668
// module chunks = 0